<template>
  <div class="abc">
    <!-- 遮罩层 -->
    <div class="mask"></div>
    <!--  情商语文-->
    <div class="item" v-show="status === 2">
      <div :class="['title', status === 2 ? 'animated fadeInUp' : '']">
        <div class="big">原生态英语</div>
        <div class="small">用母语环境提升孩子国际竞争力</div>
      </div>
      <div :class="['con', status === 2 ? 'animated fadeInUp' : '']">
        原生态英语秉承“润物细无声”的教学理念，坚持全英文教学，用浸润式的教学模式和丰富的课堂环节设置，将英语教学与孩子们的生活结合，同时大量拓展各国文化背景知识。激发学生的语言学习兴趣，培养学生的英文思维，养成良好的语言学习习惯，提升国际竞争力。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status"]
};
</script>
<style lang="less">
.abc {
  height: 100%;
  width: 100%;
  background: url(../../assets/images/English.png) center no-repeat;
  background-size: cover;
  position: relative;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 1);
    opacity: 0.6;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .item {
    position: relative;
    z-index: 2;
  }
  .title {
    animation-delay: 0.5s;
  }
  .big {
    font-size: 60px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
  }
  .small {
    font-size: 40px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 60px;
    color: rgba(204, 204, 204, 1);
    margin: 64px 0;
  }
  .con {
    animation-delay: 1s;
    width: 60%;
    font-size: 20px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 34px;
    color: rgba(204, 204, 204, 1);
    margin: auto;
  }
}
</style>
